// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VFJO","left":"styles_left__31WC4"};